import { useMutation } from "@shared/lib/hooks";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { ToastService } from "@shared/lib/services";
import {
  FINANCE_APPROVAL_QUERY_KEY,
  FINANCE_APPROVAL_QUERY_KEY_ID,
} from "../constants";
import {
  BRIEF_LIST_QUERY_KEY,
  BRIEF_LOT_FACETS_QUERY_KEY,
  nextActionToTakeEnum,
} from "@entities/brief/lib/constants";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";

export function useApproveFinanceApprovalLots(
  lotId: string,
  briefId: string,
  handleCallback: (data: {
    nextActionToTake: nextActionToTakeEnum;
    result: {
      status: string;
      reason: string;
      briefInfluencer: IBriefInfluencerV2;
      purchaseLotId: string;
      purchaseLotItemId: string;
    }[];
  }) => void
) {
  const {
    mutate: approveLots,
    isLoading: isApproving,
    isSuccess: isApproved,
    variables,
  } = useMutation({
    mutationFn: (ids: string[]) =>
      FinanceApprovalService.approveFinanceApprovalLotIds(lotId, ids).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {},
    onSuccess: (c, data) => {
      handleCallback(data.data);
      c.invalidateQueries({
        queryKey: [...BRIEF_LOT_FACETS_QUERY_KEY(briefId)],
      });
      c.invalidateQueries({
        queryKey: [...FINANCE_APPROVAL_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...FINANCE_APPROVAL_QUERY_KEY_ID(lotId)],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
    },
  });

  return {
    approveLots,
    isApproving,
    isApproved,
    variables,
  };
}
